import { render } from "./Warehouses.vue?vue&type=template&id=7463dd22&scoped=true"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"

import "./Warehouses.vue?vue&type=style&index=0&id=7463dd22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7463dd22"]])

export default __exports__